import * as actions from "../actions/actions";
import { connect } from "react-redux";
import React from "react";
import * as actionTypes from "../actions/actionTypes";

import Loading from "./loading";
import Icon from "./nounproject-ui-icon";
import EduPricing from "./nounproject-edu-pricing";

class EduApply extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.apiResponse.actionType ==
            actionTypes.SEND_EDU_APPLICATION_SUCCESS
        ) {
            this.setState({
                loading: false,
                sent: true
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            titleError: false,
            emailError: false,
            loading: false,
            sent: false
        };
    }

    validateEmail(email) {
        // eslint-disable-next-line no-useless-escape
        var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    }

    submitApplication(e) {
        e.preventDefault();
        let $this = this,
            appInfo,
            email = this.emailInput.value,
            emailHasError,
            title = this.professionalTitle.value,
            titleHasError,
            school = this.school.value,
            howDoYouUseIcons = this.howDoYouUseIcons.value;

        if (!title) {
            titleHasError = true;
        }
        if (!email || !this.validateEmail(email)) {
            emailHasError = true;
        }

        if (emailHasError || titleHasError) {
            this.setState({
                loading: false,
                emailError: emailHasError,
                titleError: titleHasError
            });
            return;
        }

        $this.setState({
            loading: true,
            application_email: email
        });

        this.props.sendEduApplication({
            email: email,
            title: title,
            school: school,
            comment: howDoYouUseIcons
        });
    }

    renderForm() {
        let titleInputClasses = ["input"],
            emailInputClasses = ["input"],
            emailLabel,
            userEmail = this.props.currentUser;

        if (this.state.titleError) {
            titleInputClasses.push("error on");
        }

        if (this.state.emailError) {
            emailInputClasses.push("error on");
            emailLabel = (
                <label htmlFor="email" className="on error show">
                    Please provide a valid contact email
                </label>
            );
        } else {
            emailLabel = (
                <label
                    htmlFor="email"
                    data-label-text="Email Address"
                    className="on show"
                >
                    Contact email
                </label>
            );
        }

        return (
            <div className="row">
                <div className="col-sm-6 padded-column">
                    <h1 className="font-large margin-b-l ">
                        NounPro for Education Application
                    </h1>
                    <p>
                        {
                            "The NounPro for Education discounted plan is reserved exclusively for educators, students, and edu staff."
                        }
                    </p>
                    <p>
                        {"To qualify, please fill out the information below."}
                    </p>
                    <form action="./" className="new-form plugin-form">
                        <ol>
                            <li className="padding-b-s">
                                <input
                                    id="professional-title"
                                    className={titleInputClasses.join(" ")}
                                    maxLength="254"
                                    name="professional-title"
                                    type="text"
                                    required=""
                                    autoFocus="autofocus"
                                    placeholder="Occupation (Student / Educator)"
                                    ref={input => {
                                        this.professionalTitle = input;
                                    }}
                                />
                                <label
                                    htmlFor="professional-title"
                                    data-label-text="Occupation"
                                    className="on show"
                                >
                                    Occupation
                                </label>
                            </li>
                            <li className="padding-b-s">
                                <input
                                    id="school"
                                    className={titleInputClasses.join(" ")}
                                    maxLength="254"
                                    name="school"
                                    type="text"
                                    required=""
                                    placeholder="School (UCLA, Los Angeles)"
                                    ref={input => {
                                        this.school = input;
                                    }}
                                />
                                <label
                                    htmlFor="school"
                                    data-label-text="School"
                                    className="on show"
                                >
                                    School
                                </label>
                            </li>
                            <li className="padding-b-s">
                                <textarea
                                    id="how-do-you-use-icons"
                                    maxLength="254"
                                    name="how-do-you-use-icons"
                                    type="text"
                                    required=""
                                    placeholder="How do you use icons?"
                                    ref={input => {
                                        this.howDoYouUseIcons = input;
                                    }}
                                />
                                <label
                                    htmlFor="how-do-you-use-icons"
                                    data-label-text="How do you use icons?"
                                    className="on show"
                                >
                                    How do you use icons?
                                </label>
                            </li>
                            <li>
                                <p>
                                    Please provide your email address so we can
                                    contact you once you're approved. If you
                                    have an .edu, .k12, .ac.uk (or equivalent)
                                    email, including it here will speed up your
                                    verification process.
                                </p>
                            </li>
                            <li className="padding-b-s">
                                <input
                                    id="email"
                                    className={emailInputClasses.join(" ")}
                                    maxLength="254"
                                    name="email"
                                    type="text"
                                    required=""
                                    placeholder="your.email@example.edu"
                                    defaultValue={window._edu_email}
                                    ref={input => {
                                        this.emailInput = input;
                                    }}
                                />
                                <label
                                    htmlFor="email"
                                    data-label-text="Email"
                                    className="on show"
                                >
                                    Email
                                </label>
                            </li>
                        </ol>
                        <button
                            className="button blue full-width ui_right-arrow"
                            type="submit"
                            onClick={this.submitApplication.bind(this)}
                        >
                            <span>Apply For Discount</span>
                        </button>
                        <p>
                            We will email you in 1-3 business days once you're
                            approved.
                        </p>
                    </form>
                </div>
                <div className="col-sm-6 col-xs-12 padded-column">
                    <EduPricing />
                </div>
            </div>
        );
    }

    renderSuccess() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div
                        style={{
                            maxWidth: "600px",
                            margin: "auto",
                            width: "100%",
                            textAlign: "center"
                        }}
                    >
                        <img
                            src={require("../../img/for_edu/il_edu_app_confirmation@2x.png")}
                            style={{
                                maxWidth: "500px",
                                width: "100%"
                            }}
                        />
                        <h1 className="font-large margin-b-l ">
                            Your application has been sent
                        </h1>
                        <p>
                            We will email you at{" "}
                            <span style={{ textDecoration: "underline" }}>
                                {this.state.application_email}
                            </span>{" "}
                            in 1-3 business days once you’re approved.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let content = <Loading />;

        if (this.state.sent) {
            content = this.renderSuccess();
        }
        if (!this.state.loading && !this.state.sent) {
            content = this.renderForm();
        }

        return <div className="container">{content}</div>;
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser,
        apiResponse = state.apiResponse;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        apiResponse,
        currentUser
    };
}

export default connect(mapStateToProps, {
    sendEduApplication: actions.sendEduApplication
})(EduApply);
